import 'preact/debug';
import * as Preact from 'preact';
import { App } from './components/app';
import * as ReactRedux from 'react-redux';
import { store } from './store';
import { StellaErrorBoundary } from './components/stellaErrorBoundary/stellaErrorBoundary';
import { ThemeBuilder } from './components/themeBuilder';
import { TranslationsWrapper } from '@dora/vivian';

Preact.render(
    <ReactRedux.Provider store={store}>
        <TranslationsWrapper>
            <ThemeBuilder>
                <StellaErrorBoundary>
                    <App />
                </StellaErrorBoundary>
            </ThemeBuilder>
        </TranslationsWrapper>
    </ReactRedux.Provider>,
    document.body,
);
